var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.noItemsAvailable && !_vm.isLoaderActive)?_c('div',{staticClass:"available-soon"},[_c('img',{attrs:{"src":_vm.itemContent.mainImg}}),_c('p',[_vm._v(_vm._s(_vm.t(_vm.itemContent.mainText)))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }